module.exports = __webpack_public_path__ + "static/media/ft-widgets.0256e270.svg";